import React from 'react';
import { RainbowButton } from './ui/rainbow-button';
import { Button } from "./ui/button"

function FeaturedCard({ title, description, imageUrl, buttonText, link, useRainbowButton = false }) {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="block">
      <div className="bg-white rounded-3xl shadow-lg overflow-hidden transition-all duration-300 hover:scale-105 hover:bg-gray-100">
        <div className="w-full">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover object-center" />
        </div>
        <div className="p-6 flex flex-col">
          <h2 className="text-2xl font-semibold mb-2">{title}</h2>
          <p className="text-gray-600 mb-4 flex-grow">{description}</p>
          <div className="relative w-full"> {/* Added w-full here */}
            {useRainbowButton ? (
              <RainbowButton>
                {buttonText}
              </RainbowButton>
            ) : (
              <Button>{buttonText}</Button>
            )}
          </div>
        </div>
      </div>
    </a>
  );
}

export default FeaturedCard;